import '../base';

import { Section } from "../tools/section";
import { Accordion } from "../objects/Accordion";

const SELECTOR_ACCORDION = '[data-accordion]';
const SELECTOR_TAB_BUTTON = '[data-accordion-tab]';
const SELECTOR_TAB_CONTENT = '[data-accordion-content]';

class AccordionSection extends Section {
  private accordions: Accordion[] = [];
  private tabButtons: NodeListOf<HTMLButtonElement> | null = null;
  private tabContents: NodeListOf<HTMLElement> | null = null;

  queryChildren(container: HTMLElement): void {
    // Query all accordions in the section (one per tab)
    const accordionElements = container.querySelectorAll<HTMLElement>(SELECTOR_ACCORDION);
    accordionElements.forEach(el => {
      this.accordions.push(new Accordion(el));
    });

    this.tabButtons = container.querySelectorAll<HTMLButtonElement>(SELECTOR_TAB_BUTTON);
    this.tabContents = container.querySelectorAll<HTMLElement>(SELECTOR_TAB_CONTENT);
  }

  attachEvents(container: HTMLElement): void {
    
    this.accordions.forEach(acc => acc.init?.());

    if (this.tabButtons && this.tabContents) {
      this.tabButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const targetTabId = btn.getAttribute('data-tab-target');
          if (!targetTabId) return;

          this.tabButtons?.forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');

          this.tabContents?.forEach(content => {
            const tabId = content.getAttribute('data-tab-id');
            content.classList.toggle('is-visible', tabId === targetTabId);
          });
        });
      });
    }
  }

  detatchEvents(): void {
    this.accordions.forEach(acc => acc.detachEvents());
  }
}

Section.register(SELECTOR_ACCORDION, AccordionSection);
